const translations = {
  'Logging In': 'Logging In...',
  'Log in with': 'Log in with {{name}}',
};

export default translations;
